export const symmetricDifference = <A>(setA: Set<A>, setB: Set<A>): Set<A> => {
  const _difference = new Set(setA)

  for (const elem of setB) {
    if (_difference.has(elem)) {
      _difference.delete(elem)
    } else {
      _difference.add(elem)
    }
  }

  return _difference
}
